var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property, queryAssignedElements } from 'lit/decorators.js';
import { appendStylesToTheStyleRoot } from '../utilities/dom';
import stylesGlobal from './_sds-sidebar-global.lit.scss';
import styles from './sds-sidebar.lit.scss';
import { styleMap } from 'lit-html/directives/style-map.js';
import { sdsCustomElement } from '../utilities/custom-components';
/**
 * `sds-sidebar` is a sidebar component designed to display navigation or contextual content.
 * The sidebar can be shown or hidden based on the value of the `toggle` attribute.
 *
 * ### Attributes
 * - `toggle`: Controls the visibility state of the sidebar.
 *
 * @tag sds-sidebar
 */
let SdsSidebar = (() => {
    var _SdsSidebar_toggle_accessor_storage, _SdsSidebar_header_accessor_storage, _SdsSidebar_footer_accessor_storage, _SdsSidebar_tabs_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-sidebar')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _toggle_decorators;
    let _toggle_initializers = [];
    let _toggle_extraInitializers = [];
    let _header_decorators;
    let _header_initializers = [];
    let _header_extraInitializers = [];
    let _footer_decorators;
    let _footer_initializers = [];
    let _footer_extraInitializers = [];
    let _tabs_decorators;
    let _tabs_initializers = [];
    let _tabs_extraInitializers = [];
    var SdsSidebar = _classThis = class extends _classSuper {
        /**
         * Controls the visibility of the sidebar. The `toggle` attribute allows switching
         * the sidebar between visible and hidden states based on the specified value.
         *
         * @attr {string} toggle - The toggle state of the sidebar.
         */
        get toggle() { return __classPrivateFieldGet(this, _SdsSidebar_toggle_accessor_storage, "f"); }
        set toggle(value) { __classPrivateFieldSet(this, _SdsSidebar_toggle_accessor_storage, value, "f"); }
        get header() { return __classPrivateFieldGet(this, _SdsSidebar_header_accessor_storage, "f"); }
        set header(value) { __classPrivateFieldSet(this, _SdsSidebar_header_accessor_storage, value, "f"); }
        get footer() { return __classPrivateFieldGet(this, _SdsSidebar_footer_accessor_storage, "f"); }
        set footer(value) { __classPrivateFieldSet(this, _SdsSidebar_footer_accessor_storage, value, "f"); }
        get tabs() { return __classPrivateFieldGet(this, _SdsSidebar_tabs_accessor_storage, "f"); }
        set tabs(value) { __classPrivateFieldSet(this, _SdsSidebar_tabs_accessor_storage, value, "f"); }
        connectedCallback() {
            super.connectedCallback();
            this.requestUpdate();
            // Listen for tab selection events
            document.addEventListener('sds.tabs.selected', event => {
                const target = event.target;
                if (target && this.closest('sds-tabs') === target.closest('sds-tabs')) {
                    requestAnimationFrame(() => this.requestUpdate());
                }
            });
        }
        render() {
            appendStylesToTheStyleRoot(this, 'sds-sidebar', this.stylesGlobal.cssText);
            return html `
            <div class="sds-sidebar" style="${this.getStyle(this.header, this.footer)}">
                ${this.renderHeader()} ${this.renderTabs()} ${this.renderContent()}
                ${this.renderFooter()}
            </div>
        `;
        }
        getStyle(el1, el2) {
            const headerElement = el1 && el1.length > 0 ? el1[0] : null;
            const footerElement = el2 && el2.length > 0 ? el2[0] : null;
            const headerOffsetHeight = headerElement ? `${headerElement.offsetHeight}px` : '0px';
            const footerOffsetHeight = footerElement ? `${footerElement.offsetHeight}px` : '0px';
            return styleMap({
                paddingTop: headerOffsetHeight,
                paddingBottom: footerOffsetHeight,
                height: `calc(100% - ${headerOffsetHeight} - ${footerOffsetHeight})`,
            });
        }
        renderHeader() {
            return html ` <slot name="header" @slotchange="${() => this.requestUpdate()}"></slot> `;
        }
        renderFooter() {
            return html ` <slot name="footer" @slotchange="${() => this.requestUpdate()}"></slot> `;
        }
        renderTabs() {
            return html ` <slot name="tabs" @slotchange="${() => this.requestUpdate()}"></slot> `;
        }
        renderContent() {
            return html `
            <div
                class="sds-sidebar__container"
                style="${this.tabs.length > 0
                ? styleMap({ display: 'contents' })
                : styleMap({ display: 'block' })}"
            >
                <slot></slot>
            </div>
        `;
        }
        constructor() {
            super(...arguments);
            this.stylesGlobal = stylesGlobal;
            _SdsSidebar_toggle_accessor_storage.set(this, __runInitializers(this, _toggle_initializers, void 0));
            _SdsSidebar_header_accessor_storage.set(this, (__runInitializers(this, _toggle_extraInitializers), __runInitializers(this, _header_initializers, void 0)));
            _SdsSidebar_footer_accessor_storage.set(this, (__runInitializers(this, _header_extraInitializers), __runInitializers(this, _footer_initializers, void 0)));
            _SdsSidebar_tabs_accessor_storage.set(this, (__runInitializers(this, _footer_extraInitializers), __runInitializers(this, _tabs_initializers, void 0)));
            __runInitializers(this, _tabs_extraInitializers);
        }
    };
    _SdsSidebar_toggle_accessor_storage = new WeakMap();
    _SdsSidebar_header_accessor_storage = new WeakMap();
    _SdsSidebar_footer_accessor_storage = new WeakMap();
    _SdsSidebar_tabs_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsSidebar");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _toggle_decorators = [property({ type: String })];
        _header_decorators = [queryAssignedElements({ slot: 'header' })];
        _footer_decorators = [queryAssignedElements({ slot: 'footer' })];
        _tabs_decorators = [queryAssignedElements({ slot: 'tabs' })];
        __esDecorate(_classThis, null, _toggle_decorators, { kind: "accessor", name: "toggle", static: false, private: false, access: { has: obj => "toggle" in obj, get: obj => obj.toggle, set: (obj, value) => { obj.toggle = value; } }, metadata: _metadata }, _toggle_initializers, _toggle_extraInitializers);
        __esDecorate(_classThis, null, _header_decorators, { kind: "accessor", name: "header", static: false, private: false, access: { has: obj => "header" in obj, get: obj => obj.header, set: (obj, value) => { obj.header = value; } }, metadata: _metadata }, _header_initializers, _header_extraInitializers);
        __esDecorate(_classThis, null, _footer_decorators, { kind: "accessor", name: "footer", static: false, private: false, access: { has: obj => "footer" in obj, get: obj => obj.footer, set: (obj, value) => { obj.footer = value; } }, metadata: _metadata }, _footer_initializers, _footer_extraInitializers);
        __esDecorate(_classThis, null, _tabs_decorators, { kind: "accessor", name: "tabs", static: false, private: false, access: { has: obj => "tabs" in obj, get: obj => obj.tabs, set: (obj, value) => { obj.tabs = value; } }, metadata: _metadata }, _tabs_initializers, _tabs_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsSidebar = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsSidebar = _classThis;
})();
export { SdsSidebar };
